import EventBus from "../events/EventBus";
import { hidePreloader } from "./preloader";
const registry = new Map();
export default function initGlobalCallbacks() {
    EventBus.on('callback:register', (event) => {
        for (const [name, callback] of Object.entries(event)) {
            registry.set(name, callback);
        }
    });
    EventBus.on('callback:execute', ({ name, args }) => {
        if (!registry.has(name)) {
            console.error(`Callback ${name} not found in the callback registry`);
            hidePreloader();
            return;
        }
        registry.get(name)(...args);
    });
}
